import { Header } from "./components/Header/Header";
import { Home } from "./pages/Home/Home";
import { Cursor } from "./shared/components/Cursor/Cursor";
import { Routes, Route } from "react-router-dom";
import { Layout } from "./pages/Layout/Layout";
import SEO from './shared/components/SEO/SEO';
import { getUrl } from "./services/get-url";
import audioPlayer from "./shared/components/AudioPlayer"

const player = audioPlayer;
player.addAudio(getUrl(`/api/audio/stream/4lbKmUgzIk0t.128.mp3`));
player.addAudio(getUrl(`/api/audio/stream/6rYrWITHT5Uz.128.mp3`));
player.addAudio(getUrl(`/api/audio/stream/cijKvSFP51ma.128.mp3`));
player.addAudio(getUrl(`/api/audio/stream/cZjJmcdwgA4Q.128.mp3`));
player.addAudio(getUrl(`/api/audio/stream/GHaOPhG29tRe.128.mp3`));
player.addAudio(getUrl(`/api/audio/stream/rtxDHHyKSvBE.128.mp3`));
player.addAudio(getUrl(`/api/audio/stream/u1ELdVFnvmrx.128.mp3`));
player.addAudio(getUrl(`/api/audio/stream/v3NyVQop4Liy.128.mp3`));
player.addAudio(getUrl(`/api/audio/stream/YBFGVqdwfMTe.128.mp3`));

player.shuffle = true;
player.loop = false;

function App() {
	return (
		<div className="app">
			<SEO />
			<Header />

			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/*" element={<Layout />} />
			</Routes>

			<Cursor />
		</div>
	);
}

export default App;
